import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CollapseComponent, EmptyStateComponent } from '@tecalisdev/infinity';
import { IOperationDocumentsDetail } from '../../../../../processes/models/processes.models';
import { IOperationDetailResponse, OPERATION_STATUS } from '../../../../models/operations.models';
import { OperationDetailOperationMetaComponent } from '../../../../../shared/components/operations/common/operation-detail-operation-meta/operation-detail-operation-meta.component';
import { OperationDocumentListItemComponent } from '../../../../../shared/components/operations/documents/operation-document-list-item/operation-document-list-item.component';

type DocumentsDetailsCollapseSection = 'documents' | 'operation';

@Component({
	selector: 'app-operation-detail-tabs-details-documents',
	imports: [
		TranslatePipe,
		CollapseComponent,
		EmptyStateComponent,
		OperationDetailOperationMetaComponent,
		OperationDocumentListItemComponent,
	],
	templateUrl: './operation-detail-tabs-details-documents.component.html',
	styleUrl: './operation-detail-tabs-details-documents.component.scss',
})
export class OperationDetailTabsDetailsDocumentsComponent implements OnChanges {
	@Input() detail: IOperationDetailResponse;

	public OPERATION_STATUS = OPERATION_STATUS;

	public docsData: IOperationDocumentsDetail | null = null;

	/** Mismo criterio acordeón que POL / OCR en detalle de operación (una sección expandida). */
	public expandedCollapseSection: DocumentsDetailsCollapseSection | null = 'documents';

	public toggleCollapse(section: DocumentsDetailsCollapseSection, expanded?: boolean): void {
		this.expandedCollapseSection = !expanded ? null : section;
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (!changes['detail']) return;
		this.docsData = this.detail?.data
			? (this.detail.data as unknown as IOperationDocumentsDetail)
			: null;
	}

	public openDocument(url: string): void {
		if (url) window.open(url, '_blank');
	}
}
